import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

import { throwSlackMutationError } from './throw-slack-mutation-error';
import type { SlackIntegration } from './types';

type Response = { data: SlackIntegration };

export const useDisconnectSlackIntegration = createMutation<
  Response,
  void,
  AxiosError
>({
  mutationFn: async () =>
    client
      .delete('v2/internal/partners/organizations/integrations/slack')
      .then((response) => response.data)
      .catch((err: any) => {
        throwSlackMutationError(err, 'Could not disconnect Slack');
      }),
});
